/* esm.sh - @internetarchive/elements@1.9.0/ia-donation-thermometer/ia-donation-thermometer */
import{__decorate as o}from"/tslib@^2.8.1?target=es2022";import{css as b,html as d,LitElement as p,nothing as c}from"/lit@^2.8.0%20||%20^3.3.2?target=es2022";import{property as i,query as u,state as g}from"/lit@^2.8.0%20||%20^3.3.2/decorators?target=es2022";function h(n){return(e,t)=>{let a=()=>{if(customElements.get(n)){console.warn(`[elements] <${n}> is already registered, so this definition was skipped and whatever registered first stays in use. Harmless when a page loads two element subpaths that share a component. Otherwise look for a second copy of the package, or an unrelated element using the same name.`);return}customElements.define(n,e)};t?t.addInitializer(a):a()}}import{msg as l,str as y}from"/@lit/localize@^0.12.2?target=es2022";import{css as v}from"/lit@^2.8.0%20||%20^3.3.2?target=es2022";var f=v`
  :host {
    /*
    BASE STYLES
    Default fallback values for theme styles. Assumes 16px root font size.
    To adjust values, use theme styles below.
    */

    /* Typography */
    --default-font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;

    /* Sizing */
    --default-icon-width: 1.25rem;
    --default-padding-sm: 5px;
    --default-combo-box-width: auto;
    --default-search-bar-width: auto;
    --default-search-bar-height: 30px;
    --default-button-padding: 0 1.875rem; /* 0 30px with 16px root font size */
    --default-button-height: 2.25rem; /* 36px with 16px root font size */
    --default-button-width: fit-content;
    --default-button-border-width: 1px;
    --default-button-border-radius: 0.25rem; /* 4px with 16px root font size */
    --default-font-size-standard: 0.875rem; /* 14px with 16px root font size */
    --default-font-size-lg: 2.25rem; /* 36px with 16px root font size */

    /* Colors */
    --true-white: #fff;
    --off-white: #fbfbfd;
    --dark-gray: #2c2c2c;
    --mid-gray: #333;
    --light-gray: #666;
    --lighter-gray: #999;
    --lightest-gray: #c5d1df;
    --classic-red: #e51c23;
    --brick: #d43f3a;
    --coral: #d9534f;
    --dark-cantaloupe: #ec7939;
    --cantaloupe: #ee8950;
    --mint-green: #31a481;
    --navy-blue: #194880;
    --bright-blue: #4b64ff;
    --default-icon-color: currentColor;
    --default-icon-filter: none;
    --default-icon-transition: none;

    /*
    ADJUSTABLE STYLES
    To be adjusted by setting i.e. --ia-theme-link-color at the :root or component level.
    */

    /* Text */
    --base-font-family: var(
      --ia-theme-base-font-family,
      var(--default-font-family)
    );
    --primary-text-color: var(--ia-theme-primary-text-color, var(--dark-gray));
    --secondary-text-color: var(
      --ia-theme-secondary-text-color,
      var(--light-gray)
    );
    --link-color: var(--ia-theme-link-color, var(--bright-blue));

    /* Sizing */
    --icon-width: var(--ia-theme-icon-width, var(--default-icon-width));
    /* Icons are square unless a height is set on its own */
    --icon-height: var(--ia-theme-icon-height, var(--icon-width));
    --padding-sm: var(--ia-theme-padding-sm, var(--default-padding-sm));
    --search-bar-height: var(
      --ia-theme-search-bar-height,
      var(--default-search-bar-height)
    );
    --search-bar-width: var(
      --ia-theme-search-bar-width,
      var(--default-search-bar-width)
    );
    --combo-box-width: var(
      --ia-theme-combo-box-width,
      var(--default-combo-box-width)
    );
    --button-padding: var(
      --ia-theme-button-padding,
      var(--default-button-padding)
    );
    --button-height: var(
      --ia-theme-button-height,
      var(--default-button-height)
    );
    --button-width: var(--ia-theme-button-width, var(--default-button-width));
    --button-border-width: var(
      --ia-theme-button-border-width,
      var(--default-button-border-width)
    );
    --button-border-radius: var(
      --ia-theme-button-border-radius,
      var(--default-button-border-radius)
    );
    --font-size-standard: var(
      --ia-theme-font-size-standard,
      var(--default-font-size-standard)
    );
    --font-size-lg: var(--ia-theme-font-size-lg, var(--default-font-size-lg));

    /* Backgrounds and fills */
    --icon-color: var(--ia-theme-icon-color, var(--default-icon-color));
    --icon-filter: var(--ia-theme-icon-filter, var(--default-icon-filter));
    --icon-transition: var(
      --ia-theme-icon-transition,
      var(--default-icon-transition)
    );
    --primary-background-color: var(
      --ia-theme-primary-background-color,
      var(--off-white)
    );
    --secondary-background-color: var(
      --ia-theme-secondary-background-color,
      var(--true-white)
    );

    /* State colors */
    /* Primary */
    --primary-cta-fill: var(--ia-theme-primary-cta-fill, var(--navy-blue));
    --primary-cta-text-color: var(
      --ia-theme-primary-cta-text-color,
      var(--true-white)
    );
    --primary-cta-border: var(
      --ia-theme-primary-cta-border,
      var(--lightest-gray)
    );

    /* Secondary */
    --secondary-cta-text-color: var(
      --ia-theme-secondary-cta-text-color,
      var(--true-white)
    );
    --secondary-cta-fill: var(--ia-theme-secondary-cta-fill, var(--mid-gray));
    --secondary-cta-border: var(
      --ia-theme-secondary-cta-border,
      var(--lighter-gray)
    );

    /* Danger */
    --danger-cta-text-color: var(
      --ia-theme-danger-cta-text-color,
      var(--true-white)
    );
    --danger-cta-fill: var(--ia-theme-danger-cta-fill, var(--coral));
    --danger-cta-border: var(--ia-theme-danger-cta-border, var(--brick));

    /* Warning */
    --warning-cta-text-color: var(
      --ia-theme-warning-cta-text-color,
      var(--true-white)
    );
    --warning-cta-fill: var(--ia-theme-warning-cta-fill, var(--cantaloupe));
    --warning-cta-border: var(
      --ia-theme-warning-cta-border,
      var(--dark-cantaloupe)
    );

    /* Disabled */
    --disabled-cta-text-color: var(
      --ia-theme-disabled-cta-text-color,
      var(--true-white)
    );
    --disabled-cta-fill: var(--ia-theme-disabled-cta-fill, var(--light-gray));
    --disabled-cta-border: var(
      --ia-theme-disabled-cta-border,
      var(--lighter-gray)
    );

    /* Standalone colors */
    --color-success: var(--ia-theme-color-success, var(--mint-green));
    --color-danger: var(--ia-theme-color-danger, var(--classic-red));
  }
`,m=f;var r=class extends p{constructor(){super(...arguments),this.goalMessageMode="amount",this.goalNearMessage=l("We\u2019ve almost reached our goal!"),this.goalReachedMessage=l("We\u2019ve reached our goal!"),this.label=l("Donation progress"),this.goalAmount=75e5,this.currentAmountMode="on",this.currentAmount=0,this.thermometerValueWidth=0,this.thermometerFillWidth=0,this.observedFillElement=null,this.observedValueElement=null}render(){return d`
      <div class="thermometer-message-container">
        <div class="thermometer-container">
          <div
            class="thermometer-background ${this.thermometerValuePosition}"
            style="--fill-end--: ${this.percentComplete}%"
            role="progressbar"
            aria-label="${this.label}"
            aria-valuemin="0"
            aria-valuemax="${this.progressMax}"
            aria-valuenow="${this.progressValue}"
            aria-valuetext="${this.currentAmountDisplayValue}"
          >
            <div class="thermometer-clip">
              <div class="thermometer-fill"></div>
            </div>
            ${this.thermometerValueTemplate}
          </div>
        </div>
        ${this.goalMessageMode!=="off"?d`<div class="donate-goal">${this.currentGoalMessage}</div>`:c}
      </div>
    `}get thermometerValueTemplate(){return this.currentAmountMode==="off"?c:d`
          <div class="thermometer-value">${this.currentAmountDisplayValue}</div>
        `}get thermometerValuePosition(){return this.thermometerValueWidth+10<this.thermometerFillWidth?"value-left":"value-right"}connectedCallback(){super.connectedCallback(),this.resizeObserver=new ResizeObserver(e=>this.handleResize(e)),this.observeParts()}disconnectedCallback(){super.disconnectedCallback(),this.resizeObserver?.disconnect(),this.resizeObserver=void 0,this.observedFillElement=null,this.observedValueElement=null}updated(){this.observeParts()}observeParts(){let e=this.resizeObserver;e&&(this.observedFillElement=this.observeInPlaceOf(e,this.observedFillElement,this.thermometerFill??null),this.observedValueElement=this.observeInPlaceOf(e,this.observedValueElement,this.thermometerValue??null))}observeInPlaceOf(e,t,a){return a===t?t:(t&&e.unobserve(t),a&&e.observe(a),a)}handleResize(e){for(let t of e){let a=t.borderBoxSize?.[0]?.inlineSize??t.contentRect.width;t.target===this.observedFillElement?this.thermometerFillWidth=a:t.target===this.observedValueElement&&(this.thermometerValueWidth=a)}}get goalMessage(){return this.currentAmount>=this.goalAmount?this.goalReachedMessage:this.goalNearMessage}get currentAmountDisplayValue(){return this.formatNumber(this.currentAmount)}get goalAmountDisplayValue(){return this.formatNumber(this.goalAmount)}formatNumber(e){if(!Number.isFinite(e)||e===0)return"$0";let t="MM",s=e/1e6;return`$${s<10?Math.round((s+Number.EPSILON)*10)/10:Math.round(s)}${t}`}get currentGoalMessage(){switch(this.goalMessageMode){case"amount":return l(y`${this.goalAmountDisplayValue} goal`);case"message":return this.goalMessage;case"off":return""}}get progressMax(){return Number.isFinite(this.goalAmount)&&this.goalAmount>0?this.goalAmount:0}get progressValue(){return Number.isFinite(this.currentAmount)?Math.min(Math.max(this.currentAmount,0),this.progressMax):0}get percentComplete(){let e=this.progressMax;if(e===0||!Number.isFinite(this.currentAmount))return 0;let t=this.currentAmount/e*100;return Math.min(Math.max(t,0),100)}static get styles(){return[m,b`
        :host {
          --donation-thermometer-height--: var(
            --ia-donation-thermometer-height,
            20px
          );
          --donation-thermometer-fill-color--: var(
            --ia-donation-thermometer-fill-color,
            #23765d
          );
          --donation-thermometer-track-color--: var(
            --ia-donation-thermometer-track-color,
            #b8f5e2
          );
          --donation-thermometer-border--: var(
            --ia-donation-thermometer-border,
            1px solid var(--donation-thermometer-fill-color--)
          );
          /* Large enough to round any height into a pill */
          --donation-thermometer-border-radius--: var(
            --ia-donation-thermometer-border-radius,
            9999px
          );
          --donation-thermometer-value-on-fill-color--: var(
            --ia-donation-thermometer-value-on-fill-color,
            var(--true-white)
          );
          --donation-thermometer-value-on-track-color--: var(
            --ia-donation-thermometer-value-on-track-color,
            var(--donation-thermometer-fill-color--)
          );
          --donation-thermometer-goal-color--: var(--primary-text-color);
          --donation-thermometer-goal-padding--: var(
            --ia-donation-thermometer-goal-padding,
            0 10px
          );

          display: block;
          height: var(--donation-thermometer-height--);
        }

        .thermometer-message-container {
          height: 100%;
          display: flex;
          align-items: center;
        }

        .thermometer-container {
          height: 100%;
          flex: 1;
        }

        .thermometer-background {
          box-sizing: border-box;
          position: relative;
          background-color: var(--donation-thermometer-track-color--);
          height: 100%;
          border-radius: var(--donation-thermometer-border-radius--);
          border: var(--donation-thermometer-border--);
        }

        /*
         * Clips the square-ended fill to the rounded track. It covers only the
         * fill, so the label is never cut off by it.
         */
        .thermometer-clip {
          position: absolute;
          inset: 0;
          overflow: hidden;
          border-radius: var(--donation-thermometer-border-radius--);
        }

        .thermometer-fill {
          background-color: var(--donation-thermometer-fill-color--);
          height: 100%;
          /*
           * The fallback matters: without it a missing --fill-end-- makes the
           * declaration invalid, width resolves to auto, and the bar paints as
           * a fully funded fundraiser.
           */
          width: var(--fill-end--, 0%);
        }

        /*
         * The label is placed by offset from the end of the fill, so it is one
         * node in one position in the DOM whichever side it shows on, and it
         * never counts towards the width of the fill it is measured against.
         */
        .thermometer-value {
          position: absolute;
          top: 0;
          bottom: 0;
          left: var(--fill-end--, 0%);
          /*
           * Without this, the left offset caps the shrink-to-fit width of a
           * translated label and it collapses to its padding.
           */
          width: max-content;
          display: flex;
          align-items: center;
          font-weight: bold;
          white-space: nowrap;
        }

        /*
         * Both paddings total 1.5rem, so changing sides leaves the label the
         * same width and cannot feed back into the side it is placed on.
         */
        .value-left .thermometer-value {
          transform: translateX(-100%);
          color: var(--donation-thermometer-value-on-fill-color--);
          padding: 0 0.5rem 0 1rem;
        }

        .value-right .thermometer-value {
          color: var(--donation-thermometer-value-on-track-color--);
          padding: 0 1rem 0 0.5rem;
        }

        .donate-goal {
          text-align: left;
          padding: var(--donation-thermometer-goal-padding--);
          text-transform: uppercase;
          font-weight: bold;
          color: var(--donation-thermometer-goal-color--);
        }
      `]}};o([i({type:String})],r.prototype,"goalMessageMode",void 0);o([i({type:String})],r.prototype,"goalNearMessage",void 0);o([i({type:String})],r.prototype,"goalReachedMessage",void 0);o([i({type:String})],r.prototype,"label",void 0);o([i({type:Number})],r.prototype,"goalAmount",void 0);o([i({type:String})],r.prototype,"currentAmountMode",void 0);o([i({type:Number})],r.prototype,"currentAmount",void 0);o([u(".thermometer-value")],r.prototype,"thermometerValue",void 0);o([u(".thermometer-fill")],r.prototype,"thermometerFill",void 0);o([g()],r.prototype,"thermometerValueWidth",void 0);o([g()],r.prototype,"thermometerFillWidth",void 0);r=o([h("ia-donation-thermometer")],r);export{r as IADonationThermometer};
//# sourceMappingURL=ia-donation-thermometer.mjs.map